import { useWSModalCustom } from "@wingspanhq/fe-component-library";
import { ModalEditWorkLogNotes } from "./index";

export const useModalEditWorkLogNotes = () =>
  useWSModalCustom(ModalEditWorkLogNotes);
